module.exports = __webpack_public_path__ + "media/images/icons/help-356f0d29fbf76711f45b6443fac8724d.svg";